import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class BlogArticle extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get id() {
    return get(this, 'system.id', '');
  }

  get categories() {
    return get(this, '_categories__blog_category.taxonomyTerms', []);
  }

  get mainCategory() {
    return get(this, '_main_category__blog_category.taxonomyTerms[0]', []);
  }

  get relatedProducts() {
    return get(this, '_related_products', []);
  }

  get title() {
    return get(this, '_title.value', '');
  }

  get slug() {
    return get(this, '_slug.value', '');
  }

  get publicationDate() {
    return get(this, '_publication_date.value', '');
  }

  get content() {
    return get(this, '_content', {});
  }

  get fullWidthListingImage() {
    return get(this, '_listing___full_width_image.value[0].url', '');
  }

  get listingImage() {
    return get(this, '_listing___image.value[0].url', '');
  }

  get articleAuthor() {
    return get(this, '_article_author[0]', {});
  }

  get linkToProduct() {
    return get(this, '_link_to_product[0]', {});
  }

  get SEO() {
    return get(this, '_seo[0].model', {});
  }

  get metaKeywords() {
    return get(this, '_meta_keywords.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/BlogArticle.model.js